export default __webpack_public_path__ + "static/media/25.e05bf5fd.png";